export enum DiskTypeEnum {
  Shtamp = 0,
  Litie = 1,
  Kovan = 2,
  Gruz = 3,
}

export const DiskTypeEnumDescription = {
  [DiskTypeEnum.Litie]: 'Литые',
  [DiskTypeEnum.Kovan]: 'Кованые',
  [DiskTypeEnum.Gruz]: 'Грузовые',
  [DiskTypeEnum.Shtamp]: 'Штампованные',
};
